import { useQuery } from "@tanstack/vue-query";
import Contact from "@/services/contact/contact";
import type { ContactChatMessagesResponse } from "@/dtos/ContactChat.dto";
import { computed, Ref } from "vue";

export function useContactChatMessages(contactId: Ref<string | null>) {
  const enabled = computed(() => !!contactId.value);

  return useQuery({
    queryKey: ["contact-chat-messages", contactId],
    queryFn: async (): Promise<ContactChatMessagesResponse> => {
      if (!contactId.value) return { messages: [], total: 0, limit: 50, offset: 0 };
      const response = await Contact.getChatMessages(contactId.value);
      return response.data.data;
    },
    enabled,
    staleTime: 1000 * 30,
    gcTime: 1000 * 60 * 5,
  });
}
